import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{staticClass:"containerApp",attrs:{"fluid":""}},[_c(VBtn,{staticClass:"buttonLogin",attrs:{"large":"","color":"primary darken-1","rounded":""},on:{"click":_vm.goToLogin}},[_vm._v("Iniciar Sesión")]),_c('Horas'),_c('Drawer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }